const soQuandashiPrefix = 'https://phoenix.quandashi.com'
const soPrefix = 'https://so.quandashi.com'
const gonggaoPrefix = 'https://gonggao.quandashi.com/#/trademarkDetail'
// const soQuandashiPrefix = '//apre-phoenix.quandashi.com/brand'
// const soPrefix = 'https://apre-so.quandashi.com'
// const gonggaoPrefix = 'https://apre-gonggao.quandashi.com'
const httpEnvBefore = 'https://'
export const Api = {
  currentEnv: 'prod',
  soQuandashi: {
    queryNoticeList: `${soQuandashiPrefix}/brandSearch/queryNoticeList`,
    queryNotice: `${soQuandashiPrefix}/brandSearch/queryNotice`,
    // queryNoticeListByImage: `${soQuandashiPrefix}/brand/${encodeURI('图形检索_返回所有数据')}`,
    queryNoticeListByImage: `${soQuandashiPrefix}/brandSearch/${encodeURI('图形商标公告查询')}`,
    getNoticeUrlApi: `${soQuandashiPrefix}/brandSearch/getNoticeUrl`,
    exportExcelByWord: `${soQuandashiPrefix}/brandSearch/exportExcel4GongGao`,
    img2pdf: `${soQuandashiPrefix}/upload/img2pdf`,
    getUserPermList: `${soQuandashiPrefix}/brandSearch/brandPerm/getUserPermList`,
    getExportList: `${soQuandashiPrefix}/brandSearch/getExportList`,
    deleteExportItemById: `${soQuandashiPrefix}/brandSearch/deleteExportItemById`,
  },
  httpEnvBefore: `${httpEnvBefore}`,
  soPrefix: `${soPrefix}`,
  gonggaoPrefix: `${gonggaoPrefix}`,
  gt4: `${soQuandashiPrefix}/shield/validateGeeTest4`
}



// WEBPACK FOOTER //
// ./src/api-prod.js